import React, { useEffect, useState } from 'react'
import { Popover, InputNumber, Button, Typography } from 'antd'
import { FontSizeOutlined } from '@ant-design/icons'
import './fontSizeControl.css'

//DEFAULT FONT SIZES (vw) PER DASHBOARD
const DEFAULT_FONT_SIZES = {
  Breakdown: 2.2,
  Buildup: 1.3,
  Haulout: 1.6,
  Recovery: 1.7,
}

const getRootFontSize = () => parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16

const remToVw = (rem) => (rem * getRootFontSize() / window.innerWidth) * 100

const vwToRem = (vw) => (vw * window.innerWidth / 100) / getRootFontSize()

const getPopoverScale = () => (window.innerWidth >= 3000 ? 4 : 1.2)

//REUSABLE BUTTON + POPOVER TO SET/RESET PER-DASHBOARD TABLE FONT SIZE
const FontSizeControl = ({ title, value, onChange, onFontSizeChange }) => {
  const defaultSize = DEFAULT_FONT_SIZES[title]
  const [popoverScale, setPopoverScale] = useState(getPopoverScale)

  useEffect(() => {
    const updatePopoverScale = () => {
      setPopoverScale(getPopoverScale())
    }

    window.addEventListener('resize', updatePopoverScale)
    return () => window.removeEventListener('resize', updatePopoverScale)
  }, [])

  const handleChange = (remValue) => {
    if (remValue === null) return

    const vwValue = parseFloat(remToVw(remValue).toFixed(2))
    onChange(vwValue)
    onFontSizeChange?.(vwValue)
  }

  const handleReset = () => {
    onChange(defaultSize)
    onFontSizeChange?.(defaultSize)
  }

  return (
    <Popover
      trigger='click'
      placement='bottom'
      title='Table Font Size (rem)'
      popupClassName='popover-transform'
      overlayStyle={{ '--popover-scale': popoverScale }}
      content={
        <div className='font-size-popover-container'>
          <div className='font-size-popover'>
            <div>
              <Typography.Text type='primary' className='font-size-label'>Set table font size</Typography.Text>
              <div className='font-size-controls'>
                <InputNumber
                  min={1}
                  step={0.1}
                  precision={1}
                  value={value === null || value === 'null' ? vwToRem(remToVw(defaultSize)) : parseFloat(vwToRem(parseFloat(value)).toFixed(1))}
                  onChange={handleChange}
                />
                <span className='font-size-unit'>rem</span>
              </div>
            </div>
            <Button block size='small' onClick={handleReset} className='use-default-button'>Set default ({vwToRem(defaultSize).toFixed(1)} rem)</Button>
          </div>
        </div>
      }
    >
      <Button className='custom-icon-button warehouse-filter' type='primary' shape='circle' icon={<FontSizeOutlined />} size='large' />
    </Popover>
  )
}

export default FontSizeControl
